const styles = ({ bodyFont, white, breakpoints }) => ({
  continuebtn: {
    margin: "0 auto",
    width: "100%",
    "& span": {
      fontFamily: bodyFont,
    },
    "& button": {
      color: white,
      backgroundImage: "linear-gradient(to right, #153862, #153862)",
      fontSize: "21px",
      width: "100%",
      height: "47px",
      textTransform: "none",
      [`@media (max-width:${breakpoints.values.sm}px)`]: {
        fontSize: "13px",
      },
    },
    "& button:disabled": {
      background: "#bdbdbd"
    }
  },
  title: {
    margin: "auto 30px",
  },
  navigate_before: {
    paddingTop: "3px",
    cursor: "pointer",
  },
  orderlaterLink: {
    margin: "15px",
    cursor: "pointer",
    "&:hover": {
      textDecorationLine: "underline",
    },
  },
  sticky: {
    "& .sticky": {
      "@media(max-width: 768px)": {
        position: "fixed",
        bottom: "0",
        left: "0",
        right: "0",
        borderRadius: "0",
        margin: "0",
        backgroundColor: "rgba(0, 0, 0, 0.10)",
      },
    },
  },
  spinner: {
    width: 30,
    height: 30,
    border: "3px solid #fff",
    borderRadius: "100%",
    borderBottomColor: "transparent",
    animation: "spinner 750ms linear infinite"
  }
});
export default styles;



// WEBPACK FOOTER //
// ./src/components/StartContainer/ContinueBtn/continueBtn.style.js